export enum VendorStatusEnum {
  NEW = 'new',
  UNDER_MODIFICATION = 'under_modification',
  PENDING_QUALIFICATION = 'pending_qualification',
  QUALIFIED = 'qualified',
  REVIEW = 'review_needed',
  REJECTED = 'rejected',
}

export enum VendorPortalStatusEnum {
  EXPIRED = 'expired',
  PENDING = 'pending',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CANCELLED = 'cancelled',
}
